'use client'

import React, { useMemo } from 'react'

import { useHolidayContext } from '@/src/contexts'
import { buildHolidayNavTabs } from '@/src/utils/holidays'
import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'

import HolidayCollectionDesktopPage from './collection'

const HolidayCollectionDesktopContainer = ({ domainCountry }: { domainCountry: string }) => {
    const { collectionData } = useHolidayContext()

    const navTabs = useMemo(
        () => (collectionData ? buildHolidayNavTabs(collectionData.sections) : []),
        [collectionData]
    )

    if (!collectionData) return null

    return (
        <ErrorBoundaryWrapper identifier="holidays-collection-desktop">
            <HolidayCollectionDesktopPage collection={collectionData} navTabs={navTabs} domainCountry={domainCountry} />
        </ErrorBoundaryWrapper>
    )
}

export default HolidayCollectionDesktopContainer
